import { render, staticRenderFns } from "./list-footer.vue?vue&type=template&id=de26a360&"
import script from "./list-footer.vue?vue&type=script&lang=js&"
export * from "./list-footer.vue?vue&type=script&lang=js&"
import style0 from "./list-footer.vue?vue&type=style&index=0&id=de26a360&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports